/** Last-resort boundary for the v4 app: says what happened and offers a reload. */
import React from 'react';

export class V4ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="v4-login">
        <div className="ds-card ds-card--pad" role="alert" style={{ maxWidth: 480 }}>
          <h1 className="ds-h2">Something went wrong on this page</h1>
          <p className="ds-small ds-muted">{this.state.error.message}</p>
          <button type="button" className="ds-btn ds-btn--primary" onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
